// extracted by mini-css-extract-plugin
export default {"Container":"Alerts_Container__O2OcJ","header":"Alerts_header__5wmXg","noalert":"Alerts_noalert__HZiT7","desc":"Alerts_desc__AzR-q"};